import './bootstrap'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from '@/components/App'
import i18n from '@/plugins/vuei18n'
import store from '@/store/store'
import router from '@/router/router'
import axios from 'axios'
import VueAuth from '@websanova/vue-auth'
import VueAxios from 'vue-axios'
import VueKonva from 'vue-konva'
import auth from './plugins/auth'
import './plugins/filters'

Vue.router = router
Vue.use(VueAxios, axios)
Vue.use(VueKonva)
axios.defaults.baseURL = window.location.origin + '/api/' + i18n.locale
Vue.use(VueAuth, auth)

const app = new Vue({
    i18n,
    router,
    store,
    vuetify,
    el: '#app',
    render: h => h(App)
})

Vue.prototype.$locale = i18n.locale

export default app
